import { matchPath } from 'react-router'

import { Pages, isCUI } from '@/consts/routes'

import { $currentPage } from './router'

if (isCUI) {
  document.documentElement.classList.add('chatting-ui')
}

$currentPage.watch((page) => {
  if (matchPath(Pages.CHATTING_UI, page)) {
    document.documentElement.classList.add('chatting-ui')
  } else {
    document.documentElement.classList.remove('chatting-ui')
  }
})
